module.exports = __webpack_public_path__ + "img/company-gray.69982efb.svg";